import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type {
  TypePostShippingLabelsCancelParams,
  TypePostShippingLabelsCancelResponse,
} from '~/types/delivery-agency.types';

const usePostShippingLabelsCancel = () => {
  const { runAsync } = useAsyncHandler();

  const postShippingLabelsPrint = useAPI<TypePostShippingLabelsCancelParams, TypePostShippingLabelsCancelResponse>({
    endpoint: API_ENDPOINT.DELIVERY_AGENCY.POST_SHIPPING_LABELS_CANCEL,
    method: 'post',
  });

  const requestDeliveryCancel = async (
    params: TypePostShippingLabelsCancelParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: (data: TypePostShippingLabelsCancelResponse['data']) => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => postShippingLabelsPrint({ params }), {
      onSuccess: ({ data }) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestDeliveryCancel };
};

export default usePostShippingLabelsCancel;
